export const API_KEY = 'b6c6TdbWJc2cPSgfVl6G42Rx0gwOk0zT';
export const API_URL = 'https://api.giphy.com/v1'

// const API_KEY = process.env.REACT_APP_APY_KEY;